import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomerLogs = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-customer-logs", jiraSpaEntry: "async-jira-eoc-customer-logs" */ '@atlassian/jira-eoc-customer-logs'
		),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomerLogsDownLoad = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-customer-logs-download", jiraSpaEntry: "async-jira-eoc-customer-logs-download" */ '@atlassian/jira-eoc-customer-logs'
	).then(({ CustomerLogsDownloadPage }) => CustomerLogsDownloadPage),
);

const AsyncCustomerLogsDownLoad = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomerLogs}
		pageId="async-jira-eoc-customer-logs"
		shouldShowSpinner={false}
	/>
);

export default AsyncCustomerLogsDownLoad;

export const CustomerLogsDownloadPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomerLogsDownLoad}
		pageId="async-jira-eoc-customer-logs-download"
		shouldShowSpinner={false}
	/>
);
